import React from "react";
import clsx from "clsx";
import { AppBar, Toolbar, Typography, IconButton } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";

import Usuario from "./Usuario";
import Atendimento from "./Atendimento";
import Produtos from "./Produtos";
import { useStyles } from "./styles";
import icon from "../../Assets/logotipo.png";

function HeaderCustom({ openMenu, handleOpenMenu }) {
  const classes = useStyles();

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: openMenu,
      })}
    >
      <Toolbar variant="dense">
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => handleOpenMenu(true)}
          edge="start"
          className={clsx(classes.menuButton, openMenu && classes.hide)}
        >
          <MenuIcon />
        </IconButton>
        <Typography className={classes.flex} variant="h6" noWrap>
            <img
              className={classes.logotipo}
              alt="Revisor Retenções de INSS para Pessoa Física"
              src={icon}
              onClick={() =>
                (window.location =
                  "https://erecuperador.e-auditoria.com.br/bemvindo")
              }
            />
        </Typography>
        <div className={classes.drawerHeader}>
          <Produtos />
          <Atendimento />
          <Usuario />
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default HeaderCustom;
